export const NAMESPACE = 'openai-assistant-service-frontend';
export const IS_OPEN_KEY = 'ask-mirena-widget-open';
